<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới Agent</h1>
      <div class="float-right">
        <router-link to="/agent" class="f12 font-medium btn btn-outline-secondary mr-2">
          <i class="bx bx-arrow-back"></i> Quay lại
        </router-link>
        <button class="f12 font-medium btn btn-primary" @click="submitForm">
          <i class="bx bx-save"></i> Lưu
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <ValidationObserver ref="agentCreate">
        <form @submit.prevent>
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <h1 class="form-inner-heading">Thông tin chung</h1>
              <ValidationProvider
                name="Họ và tên"
                rules="required|minMAxAgentName"
                v-slot="{ errors }"
              >
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Họ và tên</label>
                  <div class="col-sm-7">
                    <input
                      type="text"
                      v-model="formCreate.name"
                      :class="`form-control ${errors[0] ? 'input-err' : ''}`"
                      placeholder="Nhập họ và tên"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider name="Tên đăng nhập" rules="required|email" v-slot="{ errors }">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Tên đăng nhập</label>
                  <div class="col-sm-7">
                    <input
                      type="email"
                      v-model="formCreate.email"
                      :class="`form-control ${errors[0] ? 'input-err' : ''}`"
                      placeholder="Email công ty"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider name="Số điện thoại" rules="required" v-slot="{ errors }">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Số điện thoại</label>
                  <div class="col-sm-7">
                    <input
                      type="tel"
                      v-model="formCreate.mobile"
                      :class="`form-control ${errors[0] ? 'input-err' : ''}`"
                      placeholder="Nhập số điện thoại"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider name="Địa chỉ" rules="required" v-slot="{ errors }">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Địa chỉ</label>
                  <div class="col-sm-7">
                    <input
                      type="text"
                      v-model="formCreate.address"
                      class="form-control"
                      placeholder="Nhập địa chỉ"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider name="Tỉnh/Thành phố" rules="required" v-slot="{ errors }">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Tỉnh/Thành phố</label>
                  <div class="col-sm-7">
                    <Select2
                      @change="getDistrict($event)"
                      id="tinhtp"
                      v-model="formCreate.cityCode"
                      :options="city"
                    ></Select2>
                    <p v-if="!formCreate.cityCode" class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider name="Quận/Huyện" rules="required" v-slot="{ errors }">
                <div class="form-group row">
                  <label class="col-sm-3 col-form-label">Quận/Huyện </label>
                  <div class="col-sm-7">
                    <Select2
                      id="quanhuyen"
                      v-model="formCreate.districtCode"
                      :options="district"
                    ></Select2>
                    <p v-if="!formCreate.districtCode" class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <b-modal size="xs" v-model="toastModal.show" scrollable centered title="Thông báo">
      <div class="modal-body text-center">
        <img v-if="toastModal.success" src="@/assets/noti-success2.svg" alt="icon-successs" />
        <img v-else src="@/assets/img/noti-unsuccess2.svg" alt="icon-unsuccesss" />
        <h2 class="f18 py-3">{{ toastModal.title }}</h2>
        <p class="text-center">
          {{ toastModal.content }}
        </p>
      </div>
      <template #modal-footer="{}">
        <button type="button" class="btn btn-light" @click="closeAdd()" data-dismiss="modal">
          Đóng
        </button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { AgentService } from '@/services/agent.service'
  import { ContractService } from '@/services/contract.service'
  import { mapGetters } from 'vuex'

  export default {
    name: 'agentCreate',
    data() {
      return {
        toastModal: {
          success: false,
          show: false,
          title: null,
          content: null,
        },
        city: [],
        district: [],
        formCreate: {
          address: null,
          cityCode: null,
          agentGroupCode: 'NEXTPAY',
          districtCode: null,
          email: null,
          name: null,
          mobile: null,
        },
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    async created() {
      this.getCity()
    },
    methods: {
      async getCity() {
        await ContractService.getAllCity({}).then(response => {
          if (response.success) {
            this.city = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        })
      },
      async getDistrict(cityCode) {
        await ContractService.getDistictByCode({ cityCode }).then(response => {
          if (response.success) {
            this.district = response.data.map(e => {
              return {
                id: e.code,
                text: e.name,
              }
            })
          }
        })
      },
      setToast(title, content, success) {
        this.toastModal.show = true
        this.toastModal.title = title
        this.toastModal.content = content
        this.toastModal.success = success
      },
      submitForm() {
        const observer = this.$refs.agentCreate
        observer
          .validate()
          .then(async success => {
            if (success) {
              const tempCityName = this.city.find(
                element => element.id === this.formCreate.cityCode
              )
              this.formCreate.cityName = tempCityName.text
              const tempDistricName = this.district.find(
                element => element.id === this.formCreate.districtCode
              )
              this.formCreate.districtName = tempDistricName.text

              await AgentService.createAgent(this.formCreate).then(response => {
                if (response.success) {
                  this.setToast(null, 'Tạo agent thành công!', true)
                  // setTimeout(() => { this.$router.push('/agent') }, 1000)
                  return
                }
                this.setToast(null, response.message, false)
              })
            }
          })
          .catch(error => {
            this.setToast(null, error, false)
          })
      },
      closeAdd() {
        this.$router.push('/agent')
      },
    },
  }
</script>
